import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_GUEST_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_CREATE_DELEGATE_GUEST, KEY_POST_CREATE_DELEGATE_GUEST } from '../constants';
import { MOCK_RESPONSE_POST_CREATE_DELEGATE_GUEST } from '../mocks';

type RequestPostCreateDelegateGuest = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_GUEST_PATH_KEY
>['request']['body'];

export type CallParamsPostCreateDelegateGuest = RequestPostCreateDelegateGuest & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostCreateDelegateGuest = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DELEGATIONS_ASSIGNEES_GUEST_PATH_KEY
>['response']['body'];

type CallErrorPostCreateDelegateGuest = {
  message: string;
  code: number;
};

type CallSelectorsPostCreateDelegateGuest = unknown;

const responseMapper = () => ({
  status: 'OK',
});

export const postCreateDelegateGuestCall = createGeneralCall<
  CallParamsPostCreateDelegateGuest,
  CallResponsePostCreateDelegateGuest,
  CallErrorPostCreateDelegateGuest,
  CallSelectorsPostCreateDelegateGuest
>({
  id: KEY_POST_CREATE_DELEGATE_GUEST,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_CREATE_DELEGATE_GUEST(org as unknown as string);
  },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_CREATE_DELEGATE_GUEST : undefined,
  responseMapper,
  responseExtractor: null,
});
